import { render, staticRenderFns } from "./LabelOptional.vue?vue&type=template&id=7d6f3d56&scoped=true"
import script from "./LabelOptional.vue?vue&type=script&lang=ts"
export * from "./LabelOptional.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6f3d56",
  null
  
)

export default component.exports